import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

const store=new Vuex.Store({
	 state:{
	 	userInfo:""
	 },
	 mutations:{
	 	login:(state,data)=>{
	 		window.localStorage.setItem("token",data);
	 		state.token=data;
	 	}
	 },
	 actions:{

	 }
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js